<script lang="ts" setup>
defineProps<{
  title?: string;
}>();
</script>
<template>
  <div class="bg-white flex flex-col rounded-lg border border-gray-200">
    <div v-if="title" class="h-[64px] px-4 flex items-center justify-between">
      <slot name="header-title">
        <div class="flex flex-row items-center gap-2">
          <h3 class="text-regular font-semibold leading-6 text-gray-900">
            {{ title }}
          </h3>
          <slot name="header-description" />
        </div>
      </slot>

      <div class="space-x-2 flex items-center">
        <slot name="header" />
      </div>
    </div>
    <div :class="title ? 'pt-0' : ''" class="p-4 flex-auto"><slot /></div>
    <div v-if="$slots.footer" class="border-t border-gray-200 px-4 py-4 flex items-center justify-end flex-none">
      <slot name="footer" />
    </div>
  </div>
</template>
